import { inputTypes } from 'components/common/FormElements/Input'
import { MONTHS } from 'constant'
import {
  FIRST_NAME_PROPERTY,
  LAST_NAME_PROPERTY,
  ADDRESS_LINE1_PROPERTY,
  ADDRESS_LINE2_PROPERTY,
  CITY_PROPERTY,
  STATE_PROPERTY,
  ZIP_CODE_PROPERTY,
  CELL_PHONE_NUMBER_PROPERTY,
  OTHER_PHONE_NUMBER_PROPERTY,
  MONTH_PROPERTY,
  DAY_PROPERTY,
  BIRTHDAY_HINT_ID
} from './constants'
import { getDaysFromMonth, convertToOptions } from 'helpers/options'

export default ({
  addressSuggestions,
  resetAddresses,
  formValues,
  stateOptions = []
} = {}) => ({
  firstName: {
    label: 'First Name',
    name: FIRST_NAME_PROPERTY,
    'data-at-accountdetails-personal-info-form-firstname': true
  },
  lastName: {
    label: 'Last Name',
    name: LAST_NAME_PROPERTY,
    'data-at-accountdetails-personal-info-form-lastname': true
  },
  addressLine1: {
    label: 'Address Line 1',
    name: ADDRESS_LINE1_PROPERTY,
    inputType: inputTypes.REACT_AUTOSUGGEST_INPUT,
    onSuggestionsClearRequested: resetAddresses,
    suggestions: addressSuggestions,
    'data-at-accountdetails-personal-info-form-address1': true
  },
  addressLine2: {
    label: 'Address Line 2 (optional)',
    name: ADDRESS_LINE2_PROPERTY,
    'data-at-accountdetails-personal-info-form-address2': true
  },
  city: {
    label: 'City',
    name: CITY_PROPERTY,
    'data-at-accountdetails-personal-info-form-city': true
  },
  state: {
    label: 'State',
    name: STATE_PROPERTY,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: stateOptions,
    isSearchable: false
  },
  zipCode: {
    label: 'Zip Code',
    name: ZIP_CODE_PROPERTY,
    'data-at-accountdetails-personal-info-form-zip': true
  },
  cellPhoneNumber: {
    label: 'Phone Number',
    name: CELL_PHONE_NUMBER_PROPERTY,
    'data-at-accountdetails-personal-info-form-phonecell': true
  },
  otherPhoneNumber: {
    label: 'Other Phone Number (optional)',
    name: OTHER_PHONE_NUMBER_PROPERTY,
    'data-at-accountdetails-personal-info-form-phoneother': true
  },
  month: {
    label: 'Month',
    name: MONTH_PROPERTY,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: convertToOptions(MONTHS),
    isSearchable: false,
    'aria-describedby': BIRTHDAY_HINT_ID
  },
  day: {
    label: 'Day',
    name: DAY_PROPERTY,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: convertToOptions(getDaysFromMonth(formValues.birthMonth)),
    isSearchable: false,
    'aria-describedby': BIRTHDAY_HINT_ID
  }
})
